// Stakeholder codes (province or municipality) that have a Cyclomedia contract/API key
// configured server-side (see cyclomedia-images-get-by-coords.ts in evtools-suite).
// '28' = Zuid-Holland, '29' = Zeeland (province codes), '0392' = Haarlem (municipality code).
const CYCLOMEDIA_ENABLED_CODES = ['28', '29', '0392']

module.exports = {
  CYCLOMEDIA_ENABLED_CODES,
}
